<template>
  <form
    class="company box is-flex is-centered"
    @submit.prevent="onSubmit"
  >
    <h1 class="title is-4 has-text-primary">
      Configuración de Compañia
    </h1>
    <div class="column is-6">
      <div
        class="file is-fullwidth is-centered is-boxed"
        :class="{ 'is-success': haveLogo || logoPdfFileName, 'has-name': !haveLogo }"
      >
        <label
          class="file-container"
          for="logoPdf"
        >
          <AppInputFile
            id="logoPdf"
            accept="image/*"
            :label="checkImage"
            :value="image"
            :loading="loading"
            :disabled="loading"
            :title="titleLogo()"
            @input="validLogo"
          />
        </label>
      </div>
    </div>
    <div class="columns is-multiline">
      <div class="column is-6">
        <AppInputRfc
          :value="rfc"
          :disabled="loading || rfcBlocked"
          :is-loading="loading"
          :readonly="rfcBlocked"
          required
          @input="onChangeRfc"
          @change="onChangeRfc"
        />
      </div>

      <div class="column is-6">
        <div class="field">
          <label
            class="label"
            for="name"
          >
            Razón Social:
          </label>
          <div
            class="control has-icons-left"
            :class="{ 'has-icons-right': isValid.name, 'is-loading': loading }"
          >
            <input
              id="name"
              ref="name"
              name="name"
              class="input"
              maxlength="254"
              placeholder="Machete SA de CV"
              :value="name"
              :disabled="loading"
              required
              @input="onChangeCompany"
              @change="onChangeCompany"
            >
            <BIcon
              class="is-unselectable is-left"
              icon="label"
              size="is-small"
            />
            <BIcon
              v-if="isValid.name"
              class="is-unselectable is-right has-text-success"
              icon="done"
            />
          </div>
        </div>
      </div>

      <div class="column is-6">
        <div class="field">
          <label
            class="label"
            for="tradeName"
          >
            Nombre Comercial:
          </label>
          <div
            class="control has-icons-left"
            :class="{ 'has-icons-right': isValid.tradeName, 'is-loading': loading }"
          >
            <input
              id="tradeName"
              ref="tradeName"
              name="tradeName"
              class="input"
              maxlength="254"
              placeholder="Machete"
              :value="tradeName"
              :disabled="loading"
              required
              @input="onChangeCompany"
              @change="onChangeCompany"
            >

            <BIcon
              class="is-left is-unselectable"
              icon="label"
            />
            <BIcon
              v-if="isValid.tradeName"
              class="is-unselectable is-small is-right has-text-success"
              icon="check"
            />
          </div>
        </div>
      </div>

      <div class="column is-6">
        <AppSelectSearch
          id="regime"
          name="regime"
          label="Régimen Fiscal:"
          placeholder="Selecciona el regimen"
          :options="regimeCatalog"
          :value="regimeValue"
          :disable="loading"
          required
          @input="onChange"
          @change="onChange"
        />
      </div>

      <div class="column is-6">
        <AppInputPhoneNumber
          id="phoneNumber"
          :value="phoneNumber"
          @input="onChangePhone"
          @change="onChangePhone"
        />
      </div>
      <div class="column is-6">
        <AppInputField
          id="zipCode"
          name="zipCode"
          label="Código Postal:"
          placeholder="01230"
          :value="zipCode"
          :disable="loading"
          @input="onChange"
          @change="onChange"
        />
      </div>

      <div class="column is-12">
        <div class="field">
          <label
            class="label"
            for="password"
          >
            Contraseña de Clave Privada
          </label>
          <div
            class="control has-icons-left"
            :class="{ 'has-icons-right': isValid.password, 'is-loading': loading }"
          >
            <input
              id="password"
              ref="password"
              name="password"
              class="input"
              type="password"
              placeholder="*******"
              minlength="8"
              maxlength="50"
              :value="password"
              :disabled="loading"
              @input="onChange"
              @change="onChange"
            >
            <BIcon
              class="is-left"
              icon="lock"
              size="is-small"
            />
            <span
              v-if="isValid.password"
              class="icon is-small is-right"
            >
              <BIcon
                icon="check"
                class="is-unselectable has-text-success"
              />
            </span>
          </div>
        </div>
      </div>

      <div class="column is-6">
        <div class="field">
          <div
            class="file is-fullwidth is-centered is-boxed"
            :class="{ 'is-success': haveCer || cerFileName, 'has-name': !haveCer }"
          >
            <label
              class="file-label has-text-centered"
              for="cer"
            >
              <input
                id="cer"
                ref="cer"
                name="cer"
                class="file-input"
                type="file"
                accept=".cer"
                @change="onChangeFile"
              >
              <span class="file-cta">
                <span class="file-icon">
                  <BIcon
                    class="is-unselectable"
                    :icon="cerFileName ? 'check' : 'cloud-upload'"
                  />
                </span>
                <span class="file-label">
                  Certificado (.cer)
                </span>
              </span>
              <span
                v-if="!haveCer"
                class="file-name has-text-centered"
              >
                {{ cerFileName || 'Sube el certificado.' }}
              </span>
            </label>
          </div>
        </div>
      </div>

      <div class="column is-6">
        <div class="field">
          <div
            class="file is-fullwidth is-centered is-boxed"
            :class="{ 'is-success': haveKey || keyFileName, 'has-name': !haveKey }"
          >
            <label
              class="file-label has-text-centered"
              for="key"
            >
              <input
                id="key"
                ref="key"
                name="key"
                class="file-input"
                type="file"
                accept=".key"
                @change="onChangeFile"
              >
              <span class="file-cta">
                <span class="file-icon">
                  <BIcon
                    class="is-left"
                    size="is-small"
                    :icon="keyFileName ? 'check' : 'cloud-upload'"
                  />
                </span>
                <span class="file-label">
                  Clave privada (.key)
                </span>
              </span>
              <span
                v-if="!haveKey"
                class="file-name has-text-centered"
              >
                {{ keyFileName || 'Sube la llave.' }}
              </span>
            </label>
          </div>
        </div>
      </div>
      <div
        v-if="['612', '621'].includes(regime)"
        class="column is-12"
      >
        <div class="field">
          <label
            class="label is-flex"
            for="curp"
          >
            <div class="help-label">
              <div>CURP</div>
              <div class="has-text-gray">
                opcional
              </div>
            </div>
            <AppTooltip label="Este campo es opcional pero requerido para generar nómina" />
          </label>
          <div
            class="control has-icons-left"
            :class="{ 'is-loading': loading }"
          >
            <input
              id="curp"
              ref="curp"
              name="curp"
              class="input"
              maxlength="21"
              placeholder="BEML920313HMCLNS09"
              :value="curp"
              :disabled="loading"
              :pattern="curpPattern"
              @input="onChangeCompany"
              @change="onChangeCompany"
            >
            <BIcon
              class="is-left"
              icon="label"
              size="is-small"
            />
          </div>
        </div>
      </div>

      <div class="column is-12">
        <div class="field">
          <label
            class="label is-flex"
            for="employerRegistration"
          >
            <div>
              <div>Registro Patronal</div>
              <div class="has-text-gray">
                opcional
              </div>
            </div>
          </label>
          <div
            class="control has-icons-left"
            :class="{ 'is-loading': loading }"
          >
            <input
              id="employerRegistration"
              ref="employerRegistration"
              name="employerRegistration"
              class="input"
              maxlength="50"
              placeholder="Y68-13217-10-3"
              :value="employerRegistration"
              :disabled="loading"
              @input="onChangeCompany"
              @change="onChangeCompany"
            >
            <BIcon
              class="is-left"
              icon="label"
              size="is-small"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="field is-centered">
      <div class="control">
        <button
          class="button is-uppercase is-success"
          type="submit"
          :class="{ 'is-loading': loading }"
          :disabled="loading"
        >
          guardar información
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import upperFirst from 'lodash/upperFirst';
import get from 'lodash/get';
import merge from 'lodash/merge';
import { mapState, mapMutations, mapActions } from 'vuex';

import { taxRegime } from '@machete/common-catalogs';

export default {
  name: 'Company',
  components: {
    AppSelectSearch: () => import(/* webpackChunkName: "app-select-search" */ '@/components/AppSelectSearch.vue'),
    AppInputRfc: () => import(/* webpackChunkName: "app-input-rfc" */ '@/components/AppInputRfc.vue'),
    AppInputField: () => import(/* webpackChunkName: "app-input-field" */ '@/components/AppInputField.vue'),
    AppTooltip: () => import(/* webpackChunkName: "app-tooltip" */ '@/components/AppTooltip.vue'),
    AppInputFile: () => import(/* webpackChunkName: "app-input-file" */ '@/components/AppInputFile.vue'),
    AppInputPhoneNumber: () => import(/* webpackChunkName: "app-input-phone-number" */ '@/components/AppInputPhoneNumber.vue'),
  },
  data() {
    return {
      regimeCatalog: taxRegime.map(({ key, value }) => ({ value: key, label: `${key} - ${value}` })),
      loading: false,
      isValid: {
        name: false,
        tradeName: false,
        password: false,
        ciec: false,
      },
      curpPattern: '[A-Z][AEIOUX][A-Z]{2}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[MH]([ABCMTZ]S|[BCJMOT]C|[CNPST]L|[GNQ]T|[GQS]R|C[MH]|[MY]N|[DH]G|NE|VZ|DF|SP)[BCDFGHJ-NP-TV-Z]{3}[0-9A-Z][0-9]',
      rfcBlocked: false,
      oldPhoneNumber: this.$store.state.auth.phoneNumber,
    };
  },
  computed: merge(
    mapState({
      cerFileName: state => state.company.cerFileName,
      keyFileName: state => state.company.keyFileName,
      image: state => state.company.logoPdf,
      logo: state => state.company.logo,
      haveLogo: state => state.company.haveLogo,
      logoPdfFileName: state => state.company.logoPdfFileName,
      tradeName: state => state.company.tradeName,
      password: state => state.company.password,
      haveCer: state => state.company.haveCer,
      haveKey: state => state.company.haveKey,
      ciec: state => state.company.ciec,
      name: state => state.company.name,
      regime: state => state.company.regime,
      zipCode: state => state.company.zipCode,
      rfc: state => state.company.rfc,
      curp: state => state.company.curp,
      employerRegistration: state => state.company.employerRegistration,
      phoneNumber: state => state.auth.phoneNumber,
    }),
    {
      regimeValue() {
        // r = current regime in iteration
        const regime = this.regimeCatalog.find(r => r.value === this.regime);
        return regime;
      },
      checkImage() {
        return this.image ? '' : 'Selecciona o arrastra tu imagen';
      },
    },
  ),
  watch: {
    name() {
      this.isValid.name = this.$refs.name.checkValidity();
    },
    tradeName() {
      this.isValid.tradeName = this.$refs.tradeName.checkValidity();
    },
    password() {
      this.isValid.password = this.$refs.password.checkValidity();
    },
    ciec() {
      this.isValid.ciec = this.$refs.ciec.checkValidity();
    },
  },
  async beforeMount() {
    if (this.$route.params.id) {
      this.loading = true;

      if (parseInt(this.$route.params.id, 10) === 0) {
        this.$router.push({ name: 'Company' });
      }

      try {
        await this.getCompanyById(this.$route.params.id);
        this.rfcBlocked = true;
      } catch ({ message }) {
        this.$danger({ message });
      }
      this.loading = false;
    }
  },
  beforeDestroy() {
    this.setInitialState();
  },
  methods: {
    ...mapMutations({
      setValue: 'company/setValue',
      setInvoiceValue: 'invoice/setValue',
      setInitialState: 'company/setInitialState',
      setUserValue: 'auth/setValue',
    }),
    ...mapActions({
      getCompanyById: 'company/getCompanyById',
      updateCompany: 'company/updateCompany',
      saveCompany: 'company/saveCompany',
      updateUser: 'users/updateOwnUser',
    }),
    titleLogo() {
      return !this.image ? 'Ningún archivo seleccionado' : '';
    },
    validLogo(event) {
      const [file] = event.target.files;

      const validType = /image-*/;

      if (!file.type.match(validType)) {
        this.$danger({
          message: `El archivo no contiene un formato de imagen valido ${file.name}`,
        });

        event.target.value = '';
      } else if (file.size > 2097152) {
        const currentSize = (file.size / 1024 / 1024).toFixed(2);
        this.$danger({
          message: `El peso del archivo no debe superar los 2MB. Peso actual ${currentSize}MB`,
        });

        event.target.value = '';
      } else {
        this.onChangeFile(event);
      }
    },
    onChangeRfc(event) {
      const { name, value } = event.target;
      this.setValue({ accessor: name, value });
    },
    onChangeCompany(event) {
      const { name: accessor, value: plainValue } = event.target;

      const value = plainValue.split(' ').map(upperFirst).join(' ');

      this.setValue({ accessor, value });
    },
    onChange(event) {
      const { name: accessor, value } = event.target;
      this.setValue({ accessor, value });
    },
    onChangeFile(event) {
      const { name: accessor } = event.target;
      const [file] = event.target.files;

      this.setValue({ accessor, value: file });
      this.setValue({ accessor: `${accessor}FileName`, value: file.name });
    },
    onChangePhone(event) {
      const { name: accessor, value } = event.target;
      this.setUserValue({ accessor, value });
    },
    async onSubmit() {
      this.loading = true;

      try {
        if (this.$route.params.id) {
          await this.updateCompany(this.$route.params.id);
        } else {
          await this.saveCompany();

          await this.$store.dispatch('auth/initAuthentication');
        }

        this.updateUser({
          id: this.$store.state.auth.id,
          phoneNumber: this.phoneNumber,
          oldData: {
            phoneNumber: this.oldPhoneNumber,
          },
        });

        this.setInvoiceValue({
          accessor: 'voucherExpeditionPlace',
          value: this.zipCode,
        });

        this.setInvoiceValue({
          accessor: 'emitterRegime',
          value: this.regime,
        });

        const { stamp } = this.$route.query;

        if (stamp) {
          await this.$store.dispatch('invoice/getByUuid', stamp);
          await this.$store.dispatch('invoice/updateByUuid', {
            uuid: stamp,
            stamp: true,
          });

          this.$success({
            message: `
              Tu factura se timbro correctamente.
            `,
          });

          this.$router.push({ name: 'StampedList' });
        } else {
          this.$success({
            message: `
              La configuración se guardó correctamente.
                <br> Ya puedes comenzar a facturar.
            `,
          });

          this.$router.push({ name: 'Home' });
        }
      } catch ({ body, message }) {
        if (get(body, 'payload.keyPasswordError', false)) {
          this.$danger({
            message: `
              La contraseña no puede desencriptar el archivo:
              ${this.keyFileName}
            `,
          });
        } else if (get(body, 'payload.ciecError', false)) {
          this.$danger({ message: 'La CIEC o RFC proporcionados son inválidos.' });
        } else {
          this.$danger({ message });
        }
      }

      this.loading = false;
    },
  },
};
</script>

<style scoped>
form {
  flex-direction: column;
    margin: 0 auto;
}
.file-container{
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.46);
  background-color: #ffffff;
  margin-bottom: 1rem;
  width: 13rem;
  height: 13rem;
}

.label.is-flex {
  justify-content: space-between;
  align-items: center;
}

.has-text-gray {
  opacity: .6;
  font-size: .75rem;
}

@media screen and (max-width: 768px) {
  .column {
    max-width: 350px;
  }
}

@media screen and (min-width: 769px) {
  form {
    max-width: 800px;
  }
}
</style>
